import { render, staticRenderFns } from "./SearchSummaryList.vue?vue&type=template&id=b8a542ec"
import script from "./SearchSummaryList.vue?vue&type=script&lang=js"
export * from "./SearchSummaryList.vue?vue&type=script&lang=js"
import style0 from "./SearchSummaryList.vue?vue&type=style&index=0&id=b8a542ec&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports